export const linksConfig = {
    DISCORD_LINK: "https://discord.gg/RXBmKSdVRe",
    TWITTER_LINK: "https://x.com/shyft_hq",
    TELEGRAM_LINK: "https://t.me/+elnozTFe3OY0NDA1",
    GITHUB_LINK: "https://github.com/Shyft-to",
    YOUTUBE_LINK: "",
    BLOG_LINK: "",   
};
